<template>
  <div style="display: flex; flex-direction: row; align-items: center">
    <img
      :src="'https://graph.facebook.com/' + agent.adminid + '/picture?type=square'"
      width="50"
      height="50"
      :alt="agent.adminid"
      style="border-radius: 50%; margin-right: 10px; float: left"
      @error="onFailLoad"
    />
    <div>{{ agent.name || '-' }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['person'],
  data: function () {
    return {
      loading: true,
      agent: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agents: 'getAgent'
    })
  },
  async mounted() {
    const result = await this.handleFindAdmin()
    if (result) {
      this.agent = result
    } else {
      this.agent = {
        adminid: this.person.adminid,
        name: this.person.adminid
      }
    }
  },
  methods: {
    onFailLoad: function (event) {
      event.target.src = '/static/img/assets/livechat/profile.png'
    },
    async handleFindAdmin() {
      if (this.person.adminid) {
        // find admin
        return this.agents.find((agent) => agent.adminid === this.person.adminid)
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/LineNotifyItem.vue